import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState = {
  routes: [],
  mapLoaded: false,
  mapInstance: null,
}

const mapsSlice = createSlice({
  name: 'maps',
  initialState,
  reducers: {
    setMapLoaded: (state, action: PayloadAction<any>) => {
      state.mapLoaded = action.payload
    },
    setMapToStore: (state, action: PayloadAction<any>) => {
      state.mapInstance = action.payload
    },
  },
  extraReducers: () => {},
})

export const mapsActionsCreator = mapsSlice.actions

export default mapsSlice
